import { render, staticRenderFns } from "./PasswordPromptUpdateBackgroundComponent.vue?vue&type=template&id=98eb13fe&"
import script from "./PasswordPromptUpdateBackgroundComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordPromptUpdateBackgroundComponent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordPromptUpdateBackgroundComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports